import { useState } from "react";
import { Link } from "react-router-dom";
import ProductImagesSlider from "../components/ProductImagesSlider";
import Popup from "../components/Popup";
import "../styles/ProductCardTest.css";

const ProductCardTest = ({ product, className = "" }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [hasHovered, setHasHovered] = useState(false);

  // Determine additional classes to add based on inStock status
  const linkClass = `product-card-wrapper-container ${
    !product.in_stock ? "non-clickable-card" : ""
  } ${className}`;

  // Open the popup
  const handleOpenPopup = (e) => {
    if (!product.in_stock) {
      e.preventDefault();
      setIsPopupOpen(true);
      setHasHovered(true);
    }
  };

  return (
    <>
      <Link
        to={`/shop/${product.product_id}`}
        className={linkClass}
        onClick={handleOpenPopup} // Open popup on click
        onMouseEnter={(e) => {
          if (!product.in_stock && !hasHovered) {
            handleOpenPopup(e); // Open popup only if not already hovered
          }
        }}
      >
        {!product.in_stock && <div className="sash">Sold Out</div>}
        <ProductImagesSlider
          images={product.images}
          productName={product.name}
          showPagination={false}
        />
        <div className="info">
          <h3>{product.name}</h3>
          <p>£{product.price}</p>
        </div>
      </Link>
      <Popup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        title="Out of stock"
        description={`Join our newletter and waiting list to find out when ${product.name} are back in stock`}
        productId={product.product_id}
        reason="restock_notification"
      />
    </>
  );
};

export default ProductCardTest;
